(function () {
  function isTouchPrimaryDevice() {
    return (
      window.matchMedia('(pointer: coarse)').matches ||
      (window.matchMedia('(hover: none)').matches && 'ontouchstart' in window)
    );
  }

  function unmuteVideo(video) {
    video.muted = false;
    video.defaultMuted = false;
    video.removeAttribute('muted');
    video.volume = 1;
  }

  function playWithSound(video) {
    unmuteVideo(video);
    return video.play();
  }

  function playFromStartWithSound(video) {
    unmuteVideo(video);
    video.currentTime = 0;
    return video.play();
  }

  function bindSoundOnFirstGesture(video, restartFromStart) {
    function activate() {
      var playPromise = restartFromStart ? playFromStartWithSound(video) : playWithSound(video);
      playPromise.catch(function () {
        unmuteVideo(video);
        video.play().catch(function () {});
      });
      cleanup();
    }

    function cleanup() {
      ['touchstart', 'click', 'keydown', 'pointerdown'].forEach(function (eventName) {
        document.removeEventListener(eventName, activate, true);
      });
    }

    ['touchstart', 'click', 'keydown', 'pointerdown'].forEach(function (eventName) {
      document.addEventListener(eventName, activate, {
        once: true,
        capture: true,
        passive: eventName === 'touchstart',
      });
    });
  }

  function initVideoSound(video) {
    if (!video || video.dataset.soundInit === 'true') return;
    video.dataset.soundInit = 'true';

    var isTouch = isTouchPrimaryDevice();
    unmuteVideo(video);

    function onBlocked() {
      if (isTouch) {
        video.muted = true;
        video.play().catch(function () {});
        bindSoundOnFirstGesture(video, true);
        return;
      }

      // Desktop: sin mute — primer clic/tecla reinicia desde 0 con sonido.
      video.pause();
      video.currentTime = 0;
      bindSoundOnFirstGesture(video, true);
    }

    playFromStartWithSound(video).catch(onBlocked);

    if (!isTouch) {
      ['canplay', 'loadeddata'].forEach(function (eventName) {
        video.addEventListener(
          eventName,
          function () {
            if (video.paused) {
              playFromStartWithSound(video).catch(onBlocked);
            }
          },
          { once: true }
        );
      });

      video.addEventListener('click', function () {
        unmuteVideo(video);
        if (video.paused) {
          playFromStartWithSound(video).catch(function () {});
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('.video-section__stage video').forEach(initVideoSound);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
